import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

import MagnifyGlassIcon from '~/public/static/images/svg/magnifyingGlassIcon.svg'
import Dropdown from '~/components/Form/Dropdown'

@inject(all => ({
  trafficSubmission: all.store.trafficSubmission,
  selectedState: all.store.trafficSubmission.selectedState,
  trafficStates: all.store.trafficSubmission.trafficStates
}))
@observer
class StatesDropdown extends React.Component {
  componentDidMount() {
    this.props.trafficSubmission.loadTrafficStates()
  }

  buildOptions = () => {
    const { trafficStates } = this.props

    return trafficStates
      .slice()
      .sort((a, b) => {
        if (a.longName < b.longName) {
          return -1
        }
        if (a.longName > b.longName) {
          return 1
        }
        return 0
      })
      .map(state => ({
        value: state.shortName,
        label: state.longName
      }))
  }

  render() {
    const { trafficSubmission, selectedState, controlLabel, noBorder, placeholder } = this.props
    const options = this.buildOptions()
    return (
      <Dropdown
        autoFocus
        blurInputOnSelect
        maxMenuHeight={140}
        imgSrc={this.props.noIcon ? null : MagnifyGlassIcon}
        value={selectedState.shortName ? {
          value: selectedState.shortName,
          label: selectedState.longName
        } : null}
        onChange={trafficSubmission.setSelectedState}
        options={options}
        controlLabel={controlLabel}
        noBorder={noBorder}
        placeholder={placeholder}
        bold={false}
        searchStrategy={"start"}
      />
    )
  }
}

StatesDropdown.defaultProps = {
  controlLabel: ''
}

StatesDropdown.propTypes = {
  controlLabel: PropTypes.string
}

export default StatesDropdown
